import { useQuery } from "@tanstack/react-query";
import { fetchMandateSummary, type MandateParams } from "../api/client.ts";

// Slower-moving than the freshness chip (30d stats, 24h uptime), so a calmer
// poll. Keyed on the market; refetches on binding change.
const POLL_MS = 30_000;

export function useMandateSummary(p: MandateParams) {
  return useQuery({
    queryKey: ["mandate-summary", p.clientId, p.venue, p.pair],
    queryFn: () => fetchMandateSummary(p),
    refetchInterval: POLL_MS,
    staleTime: POLL_MS,
  });
}
